"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConsoleLogMessages = void 0;
const common_1 = require("../common");
const initializeSourceMap_1 = require("./initializeSourceMap");
exports.createConsoleLogMessages = async (actions, sourceMaps, options) => {
    if (process.env.NODE_ENV === 'production' && process.env.NEO_ONE_DEV !== 'true') {
        return [];
    }
    initializeSourceMap_1.initializeSourceMap();
    return common_1.createConsoleLogMessages(actions, sourceMaps, options);
};

//# sourceMappingURL=createConsoleLogMessages.js.map
